import "../../styles/settings/setting.css";
import Template from "../Template";
import { IoPersonSharp, IoCard } from "react-icons/io5";
import { MdLanguage } from "react-icons/md";
import { FaWallet } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { RiCustomerService2Fill } from "react-icons/ri";
import { IoMdHelpCircle } from "react-icons/io";
import { useState, useLayoutEffect } from "react";
import Profile, { ProfilePage } from "./Profile.jsx";
import ManageSubscription from "./ManageSubscription.jsx";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ChangePassword from "./ChangePassword.jsx";
import Wallet from "./Wallet.jsx";
import HelpSupport from "./HelpSupport.jsx";
import PrivacyDataInfo from "./PrivacyAndData.jsx";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MobileNavDrawer from "./MobileNavigation.jsx";
import ReferralsProgram from "./ReferalProgram/ReferralProgram.jsx";

const SettingScreen = () => {
  const [tab, setTab] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { tab: urlTab } = useParams();

  useLayoutEffect(() => {
    // check if a parameter is passed in the URL
    // if so, set the tab accordingly
    if (urlTab) {
      setTab(urlTab);
    } else {
      setTab("subscription"); // default tab
    }
  }, []);

  /*  useEffect(() => {
    console.log(tab);
  }, [tab]); */

  const switchTab = (e) => {
    let targetDiv = e.target;
    let targetDivParentChildren = targetDiv.parentElement.children;
    Array.from(targetDivParentChildren).forEach((child) => {
      child.classList.remove("focuedSettingMenu");
    });
    targetDiv.classList.add("focuedSettingMenu");
  };

  const profileClicked = (e, tab) => {
    switchTab(e);

    switch (tab) {
      case "profile":
        setTab("profile");
        break;
      case "subscription":
        setTab("subscription");
        break;
      case "language":
        setTab("language");
        break;
      case "referral":
        setTab("wallet");
        break;
      case "password":
        setTab("password");
        break;
      case "support":
        setTab("support");
        break;
      case "data":
        setTab("data");
        break;

      default:
        break;
    }
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  return (
    <>
      <Template>
        <div className='settingsTitleDiv'>
          <p>Settings</p>
          <div onClick={handleOpenDrawer} className='settingMenuMobile'>
            {openDrawer ? <ChevronRight /> : <ChevronLeft />}
          </div>
        </div>
        <div className='settingsWrapperDiv'>
          <div>
            <div className='settingMenu'>
              <div className={tab === "profile" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "profile")}>
                <IoPersonSharp size={23} />
                <span>Profile</span>
              </div>
              <div className={tab === "subscription" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "subscription")}>
                <IoCard size={23} />
                <span>Manage subscription</span>
              </div>
              {/* <div className={tab === "language" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "language")}>
                <MdLanguage size={18} />
                <span>Change language</span>
              </div> */}
              <div className={tab === "referral" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "wallet")}>
                <FaWallet size={23} />
                <span>Wallet</span>
              </div>
              <div className={tab === "password" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "password")}>
                <RiLockPasswordFill size={23} />
                <span>Change password</span>
              </div>
              <div className={tab === "support" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "support")}>
                <RiCustomerService2Fill size={23} />
                <span>Help & support</span>
              </div>
              <div className={tab === "data" ? "focuedSettingMenu" : {}} onClick={(e) => profileClicked(e, "data")}>
                <IoMdHelpCircle size={23} />
                <span>Privacy and data info</span>
              </div>
            </div>
            {/*  <div>
              <p className='deleteprofile'>Delete Account</p>
            </div> */}
          </div>
          <div>
            {tab === "profile" && <ProfilePage />}
            {tab === "subscription" && <ManageSubscription />}
            {tab === "password" && <ChangePassword />}
            {tab === "referral" && <ReferralsProgram />}
            {/* {tab === "wallet" && <Wallet />} */}
            {tab === "support" && <HelpSupport />}

            {tab === "data" && <PrivacyDataInfo />}
          </div>
        </div>
        {openDrawer && <MobileNavDrawer setOpenDrawer={setOpenDrawer} setTab={setTab} />}
      </Template>
    </>
  );
};

export default SettingScreen;
